import { render, staticRenderFns } from "./reject_participant_from_creator.vue?vue&type=template&id=54d82436&scoped=true&"
import script from "./reject_participant_from_creator.vue?vue&type=script&lang=js&"
export * from "./reject_participant_from_creator.vue?vue&type=script&lang=js&"
import style0 from "./reject_participant_from_creator.vue?vue&type=style&index=0&id=54d82436&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d82436",
  null
  
)

export default component.exports